import {rgba} from "polished";
import {ReactElement, ReactNode} from "react";
import styled from "styled-components";

import IconCross from "@/assets/iconCross.svg?react";
import {Button} from "@/components/Button/Button";
import {breakpoints} from "@/GlobalStyle";

const BlocFullScreenOpacity = styled.div`
  z-index: 99999;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  min-width: 320px;
  background-color: ${({theme}) => rgba(theme.colors.grey, 0.4)};
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ModalElement = styled.div<{
  $theme: "primary" | "secondary" | "validate" | "alert";
}>`
  display: flex;
  flex-direction: column;
  cursor: default;
  position: relative;
  background-color: white;
  border: 0.5rem solid
    ${({$theme, theme}) =>
      $theme === "primary"
        ? theme.colors.mediumPrimary
        : $theme === "secondary"
          ? theme.colors.mediumSecondary
          : $theme === "validate"
            ? theme.colors.validate
            : theme.colors.alert};
  box-shadow: 0 0 6px 0 ${({theme}) => theme.colors.shadowBloc};
  padding: 1.25rem;
  min-width: 60vw;
  max-width: 80vw;
  min-height: 50px;
  overflow: auto;
  max-height: 80vh;
  container: modalContent / inline-size;

  @media (min-width: 1920px) {
    min-width: 1000px;
  }
  @media (max-width: ${breakpoints.lg}) {
    padding: 1rem;
    max-width: calc(90vw- 2rem);
    width: 100%;
    min-width: 256px;
  }
`;

const ButtonClose = styled(Button)<{
  $theme: "primary" | "secondary" | "validate" | "alert";
}>`
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 5px;
  border-color: ${({$theme, theme}) =>
    $theme === "alert"
      ? theme.colors.alert
      : $theme === "validate"
        ? theme.colors.validate
        : theme.colors.mediumSecondary};
`;

export function Modal({
  children,
  close,
  isOpen,
  theme = "secondary",
}: {
  children?: ReactNode;
  close: () => void;
  isOpen: boolean;
  theme?: "primary" | "secondary" | "validate" | "alert";
}): ReactElement | null {
  if (isOpen) {
    return (
      <BlocFullScreenOpacity
        onMouseDown={() => {
          close();
        }}>
        <ModalElement onMouseDown={e => e.stopPropagation()} $theme={theme}>
          {children}
          <ButtonClose
            $theme={theme}
            icon={IconCross}
            isCircle={true}
            type="button"
            onClick={close}
            variant="negatif_secondary"
          />
        </ModalElement>
      </BlocFullScreenOpacity>
    );
  }
  return null;
}
